"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wechatOpenPlatformApi = require("@/api/wechatOpenPlatformApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      platforms: [],
      list: [],
      total: 0,
      loading: false,
      pollTimer: null,
      detailVisible: false,
      detailLoading: false,
      syncing: false,
      detail: {},
      detailRow: null,
      query: {
        platformId: null,
        keyword: '',
        authorizationStatus: '',
        page: 1,
        limit: 10
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var ready, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0, _wechatOpenPlatformApi.getPlatformList)();
          case 1:
            _t = _context.v;
            if (_t) {
              _context.n = 2;
              break;
            }
            _t = [];
          case 2:
            this.platforms = _t;
            ready = this.platforms.find(function (item) {
              return item.enabled === 1;
            });
            if (ready) this.query.platformId = ready.id;
            _context.n = 3;
            return this.load();
          case 3:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _wechatOpenPlatformApi.getAuthorizerAppList)(this.query);
            case 2:
              data = _context2.v;
              this.list = data.list || [];
              this.total = data.total || 0;
            case 3:
              _context2.p = 3;
              this.loading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    search: function search() {
      this.query.page = 1;
      this.load();
    },
    reset: function reset() {
      this.query.keyword = '';
      this.query.authorizationStatus = '';
      this.query.page = 1;
      this.load();
    },
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    sizeChange: function sizeChange(limit) {
      this.query.limit = limit;
      this.query.page = 1;
      this.load();
    },
    showDetail: function () {
      var _showDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.detailRow = row;
              this.detail = {};
              this.detailVisible = true;
              this.detailLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _wechatOpenPlatformApi.getAuthorizerAppDetail)(this.query.platformId, row.companyAppId);
            case 2:
              this.detail = _context3.v;
            case 3:
              _context3.p = 3;
              this.detailLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function showDetail(_x) {
        return _showDetail.apply(this, arguments);
      }
      return showDetail;
    }(),
    syncDetail: function () {
      var _syncDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.detailRow) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.syncing = true;
              _context4.p = 2;
              _context4.n = 3;
              return (0, _wechatOpenPlatformApi.syncAuthorizerAppDetail)(this.query.platformId, this.detailRow.companyAppId);
            case 3:
              this.detail = _context4.v;
              this.$message.success('同步成功');
              _context4.n = 4;
              return this.load();
            case 4:
              _context4.p = 4;
              this.syncing = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2,, 4, 5]]);
      }));
      function syncDetail() {
        return _syncDetail.apply(this, arguments);
      }
      return syncDetail;
    }(),
    authorize: function () {
      var _authorize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _this = this;
        var platform, win, result, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              platform = this.platforms.find(function (item) {
                return item.id === _this.query.platformId;
              });
              if (!(!platform || !platform.ticketReceived)) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('当前服务商尚未收到Ticket，请先检查微信开放平台回调配置');
              return _context5.a(2);
            case 1:
              // 先同步打开空白页，避免接口请求完成后再打开窗口被浏览器拦截。
              win = window.open('about:blank', '_blank');
              _context5.p = 2;
              _context5.n = 3;
              return (0, _wechatOpenPlatformApi.startAuthorization)({
                platformId: this.query.platformId,
                companyAppId: row.companyAppId
              });
            case 3:
              result = _context5.v;
              if (win) win.location.href = result.authorizationUrl;else this.$message.warning('浏览器阻止了授权窗口，请允许本站打开新窗口后重试');
              this.$message.info('请在微信页面完成授权，本页会自动刷新状态');
              this.poll(result.sessionId, 0);
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t2 = _context5.v;
              if (win) win.close();
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 4]]);
      }));
      function authorize(_x2) {
        return _authorize.apply(this, arguments);
      }
      return authorize;
    }(),
    poll: function poll(sessionId, attempts) {
      var _this2 = this;
      this.stopPolling();
      this.pollTimer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var session, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return (0, _wechatOpenPlatformApi.getAuthorizationSession)(sessionId);
            case 1:
              session = _context6.v;
              if (!(session.status === 'SUCCESS')) {
                _context6.n = 3;
                break;
              }
              _this2.$message.success('小程序授权成功');
              _this2.stopPolling();
              _context6.n = 2;
              return _this2.load();
            case 2:
              return _context6.a(2);
            case 3:
              if (!(session.status === 'FAILED' || session.status === 'EXPIRED')) {
                _context6.n = 4;
                break;
              }
              _this2.$message.error(session.errorMessage || '授权失败或已过期');
              _this2.stopPolling();
              return _context6.a(2);
            case 4:
              if (attempts < 120) _this2.poll(sessionId, attempts + 1);
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t3 = _context6.v;
              _this2.stopPolling();
            case 6:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 5]]);
      })), 2000);
    },
    stopPolling: function stopPolling() {
      if (this.pollTimer) clearTimeout(this.pollTimer);
      this.pollTimer = null;
    }
  }
};